export { categoryFromTags, categoryFromText } from '@goaltree/backend/convex/lib/habitCategory'

// Case/punctuation-insensitive title key, for spotting a habit that already exists.
export function normalizeTitle(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, '')
    .replace(/\s+/g, ' ')
    .trim()
}
